<template>
  <b-modal
    v-model="showModal"
    @hide="$emit('on-hide')"
    hide-footer
    hide-header
    centered
    body-class="pd-0"
    size="lg"
  >
    <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
      <a
        @click="$emit('on-hide')"
        role="button"
        class="close pos-absolute t-15 r-15"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </a>
      <div class="media align-items-center">
        <span class="tx-color-03 d-none d-sm-block">
          <feather type="mail" class="wd-40-f ht-40-f"></feather>
        </span>
        <div class="media-body mg-sm-l-20">
          <h4 class="tx-18 tx-sm-20 mg-b-2">И-мэйл мэдэгдэл илгээх</h4>
          <p class="tx-13 tx-color-03 mg-b-0">
            Мэдээллээ нягтлаад илгээх дарна уу.
          </p>
        </div>
      </div>
    </div>
    <div v-if="!isSend" class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
      <div v-if="!processing">
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Хэнээс (и-мэйл)</label
          >
          <label class="form-control text-muted">{{ config.mail }}</label>
        </div>
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Илгээх хэрэглэгчийн тоо</label
          >
          <label class="form-control text-muted">{{ config.count }}</label>
        </div>
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Гарчиг</label
          >
          <input class="form-control" type="text" v-model="config.subject" />
        </div>
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Агуулга</label
          >
          <div class="">
            <summernote
              v-model="config.body"
              :text="config.body"
              :key="summerKey"
              class="m-t-sm m-b-sm"
            ></summernote>
          </div>
        </div>
      </div>
      <div v-else>
        <div>И-мэйл илгээж байна...</div>
      </div>
    </div>
    <div v-else class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
      <div class="alert alert-success" role="alert">
        <h4 class="alert-heading">Амжилттай илгээлээ.</h4>
        <p>{{ config.count }} хэрэглэгчид и-мэйл мэдэгдэл амжилттай илгээлээ</p>
      </div>
    </div>
    <div class="modal-footer pd-x-20 pd-y-15">
      <button
        @click="$emit('on-hide')"
        type="button"
        class="btn btn-white"
        data-dismiss="modal"
      >
        {{ isSend ? "Хаах" : "Болих" }}
      </button>
      <button
        v-show="!isSend"
        @click="sendIcsMail()"
        type="button"
        class="btn btn-primary"
      >
        Илгээх
      </button>
    </div>
  </b-modal>
</template>

<script>
import { request } from "@/api/all";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
    prms: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rdy: false,
      config: {},
      summerKey: 0,
      isSend: false,
      processing: false,
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      request({
        api: { method: "post", url: "v2/Learn/SendCourseNotifMailCount" },
        data: {
          courseId: this.prms.courseId,
          objectId: this.prms.objectId,
          boxId: this.prms.boxId,
          objectTypeId: this.prms.objectTypeId,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.rdy = true;
          //console.log(res.data);
          this.config = res.data;
          this.summerKey++;
        }
      });
    },
    sendIcsMail() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.processing = true;

      request({
        api: { method: "post", url: "v2/Learn/SendCourseNotifMail" },
        data: {
          courseId: this.prms.courseId,
          objectId: this.prms.objectId,
          boxId: this.prms.boxId,
          objectTypeId: this.prms.objectTypeId,
          subject: this.config.subject,
          body: this.config.body,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.isSend = true;
          //this.isSend = true;
        }
      });
    },
  },
  computed: {
    showModal: {
      get: function () {
        if (this.isShow) this.init();
        return this.isShow;
      },
      set: function () {},
    },
  },
};
</script>
